import script from "./UserRegistrationView.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRegistrationView.vue?vue&type=script&setup=true&lang=js"

import "./UserRegistrationView.vue?vue&type=style&index=0&id=bc1be4ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc1be4ba"]])

export default __exports__